import { readCodeSequence } from './readCodeSequence';

const formatAnnotation = (waveFormAnnotations) => {
  let qt = '';
  let qtc = '';
  let pAxis = '';
  let qrsAxis = '';
  let tAxis = '';

  waveFormAnnotations.forEach((annotation) => {
    if (annotation.numericValue === undefined) annotation.numericValue = ' ';
    if (annotation.codeMeaning === 'QT Interval') qt = annotation.numericValue;
    if (annotation.codeMeaning === 'QT Corrected Duration') qtc = annotation.numericValue;
    if (annotation.codeMeaning === 'P Axis') pAxis = annotation.numericValue;
    if (annotation.codeMeaning === 'QRS Axis') qrsAxis = annotation.numericValue;
    if (annotation.codeMeaning === 'T Axis') tAxis = annotation.numericValue;
  });

  const qtQtc = { codeMeaning: '', numericValue: '' };
  qtQtc.codeMeaning = 'QT/QTc';
  qtQtc.numericValue = qt.concat('/', qtc);
  waveFormAnnotations.push(qtQtc);

  const pQrsT = { codeMeaning: '', numericValue: '' };
  pQrsT.codeMeaning = 'P-QRS-T';
  pQrsT.numericValue = pAxis.concat(' ', qrsAxis, ' ', tAxis);
  waveFormAnnotations.push(pQrsT);
};

export const createECGInstanceObject = (dataSet) => {
  // make the image based on whether it is color or not
  // const sopClassUID = dataSet.string('x00080016');

  // switch (sopClassUID) {
  //   case '1.2.840.10008.5.1.4.1.1.9.1.1': // 12-lead ECG Waveform Storage
  //   case '1.2.840.10008.5.1.4.1.1.9.1.2': // General ECG Waveform Storage
  //   case '1.2.840.10008.5.1.4.1.1.9.2.1': // Hemodynamic Waveform Storage

  // Structure: Waveform - Multiplex - channel - sample
  // const waveform = {};

  // const channelSourceSequence = dataSet.elements.x003a0208;
  // if (channelSourceSequence !== undefined) {
  //   if (channelSourceSequence.items.length > 0) {
  //   }
  // }

  const ecgSequence = [];
  const waveFormAnnotations = [];

  const ecgData = {
    sequences: ecgSequence,
    modality: '',
    manufacturer: '',
    StudyDate: '',
    StudyTime: '',
    lowFrequency: NaN,
    highFrequency: NaN,
    notchFrequency: NaN,
    annotations: waveFormAnnotations,
  };

  ecgData.modality = dataSet.string('x00080060');
  ecgData.manufacturer = dataSet.string('x00080070');
  ecgData.StudyDate = dataSet.string('x00080020');
  ecgData.StudyTime = dataSet.string('x00080030');

  // ~~~~ANOTATIONS
  const waveFormAnnotationSequence = dataSet.elements.x0040b020;
  if (waveFormAnnotationSequence !== undefined) {
    if (waveFormAnnotationSequence.items.length > 0) {
      // cada item es una PQRST ????
      let textObservations = [];
      waveFormAnnotationSequence.items.forEach((item) => {
        if (item.tag === 'xfffee000') {
          // Dicom 'item' tag
          const annGroup = item.dataSet.elements.x0040a043; // Q Concept Name Code Sequence
          const annotationsTag = {
            /*  codeValue : '', codingSchemeDesignator : '', codingSchemeVersion: '', */ codeMeaning: '',
            numericValue: '',
          };
          annotationsTag.numericValue = item.dataSet.string('x0040a30a'); // DS Numeric Value
          if (item.dataSet.elements.x00700006) {
            const value = item.dataSet.string('x00700006');
            if (value) {
              textObservations.push(value);
            }
          }
          if (annGroup !== undefined) {
            if (annGroup.items.length > 0) {
              annGroup.items.forEach((annItem) => {
                if (annItem.tag === 'xfffee000') {
                  const codeSequence = annItem.dataSet;

                  annotationsTag.codeMeaning = codeSequence.string('x00080104'); // LO Code Meaning
                  /* annotationsTag.codeValue = codeSequence.string('x00080100');
                  annotationsTag.codingSchemeDesignator = codeSequence.string('x00080102');
                  annotationsTag.codingSchemeVersion = codeSequence.string('x00080103'); */
                  waveFormAnnotations.push(annotationsTag);
                }
              });
            }
          }
        }
      });
      let textObservation = textObservations.join(' ');
      waveFormAnnotations.push({ codeMeaning: 'Text Observation Value', numericValue: '/', stringValue: textObservation });
    }
  }

  formatAnnotation(waveFormAnnotations);

  // ~~~~~~~~~~ WAVEFORM SEQUENCE - MULTIPLEX
  const waveformSequence = dataSet.elements.x54000100; // SQ Waveform Sequence
  if (waveformSequence !== undefined) {
    // console.log('Waveform data is present');
    if (waveformSequence.items.length > 0) {
      // let multiplex;
      // waveform.multiplexGroup = {};

      waveformSequence.items.forEach((item) => {
        const sequenceData = [];
        // console.log(`Item tag: ${item.tag}`);
        if (item.tag === 'xfffee000') {
          // item start tag
          // console.log('item start tag', item);
          const multiplexGroup = item.dataSet;
          const mg = {}; // multiplexGroup

          mg.waveformOriginality = multiplexGroup.string('x003a0004'); // VR = CS
          mg.numberOfWaveformChannels = multiplexGroup.uint16('x003a0005'); // VR = US
          mg.numberOfWaveformSamples = multiplexGroup.uint32('x003a0010'); // VR = UL
          mg.samplingFrequency = multiplexGroup.floatString('x003a001a'); // VR = DS
          mg.multiplexGroupLabel = multiplexGroup.string('x003a0020'); // VR = SH
          // Initialization of channels
          mg.channels = [];
          // for (let numChannel = 0; numChannel < mg.numberOfWaveformChannels; numChannel++) {
          //   console.log(numChannel);
          //   const chartId = `myChart_${numChannel}`;
          //   // addDOMChart('myWaveform', chartId);
          // }

          const channelDefinitionSequence = multiplexGroup.elements.x003a0200;
          let numDefinition = 0;
          if (channelDefinitionSequence !== undefined) {
            if (channelDefinitionSequence.items.length > 0) {
              channelDefinitionSequence.items.forEach((item) => {
                if (item.tag === 'xfffee000') {
                  // item start tag
                  const channelDefinition = item.dataSet;
                  const cd = {}; // channelDefinition
                  cd.channelSource = readCodeSequence(channelDefinition.elements.x003a0208);

                  // http://stackoverflow.com/questions/12855400/rchannel-sensitivity-in-dicom-waveforms

                  cd.channelSensitivity = channelDefinition.string('x003a0210'); // VR = DS
                  cd.channelSensitivityUnits = readCodeSequence(channelDefinition.elements.x003a0211);
                  cd.channelSensitivityCorrectionFactor = channelDefinition.string('x003a0212'); // VR = DS
                  cd.channelBaseline = channelDefinition.string('x003a0213'); // VR = DS
                  // cd.channelTimeSkew = channelDefinition.string('x003a0214'); // VR = DS
                  // cd.channelSampleSkew = channelDefinition.string('x003a0215'); // VR = DS
                  cd.waveformBitsStored = channelDefinition.uint16('x003a021a'); // VR = US
                  cd.filterLowFrequency = channelDefinition.string('x003a0220'); // VR = DS
                  cd.filterHighFrequency = channelDefinition.string('x003a0221'); // VR = DS
                  cd.filterNotchFrequency = channelDefinition.string('x003a0222'); // VR = DS
                  cd.filterNotchBandwidth = channelDefinition.string('x003a0223'); // VR = DS

                  ecgData.lowFrequency = cd.filterLowFrequency;
                  ecgData.highFrequency = cd.filterHighFrequency;
                  ecgData.notchFrequency = cd.filterNotchFrequency === undefined ? 0 : cd.filterNotchFrequency;

                  mg.channels[numDefinition] = {};
                  mg.channels[numDefinition].channelDefinition = cd;
                  mg.channels[numDefinition].samples = [];

                  // channel definition undefined
                  //
                  numDefinition++;
                }
              });
            }
          }

          mg.waveformBitsAllocated = multiplexGroup.uint16('x54001004'); // VR = US
          mg.waveformSampleInterpretation = multiplexGroup.string('x54001006'); // VR = CS

          let waveformPaddingValue = multiplexGroup.int16('x5400100a'); // VR = OB or OW (OW->SS)

          switch (mg.waveformBitsAllocated) {
            case 8:
              // switch (mg.waveformSampleInterpretation) {
              //   case 'SB': // signed 8 bit linear
              //   case 'UB': // unsigned 8 bit linear
              //   case 'MB': // 8 bit mu-law (in accordance with ITU-T Recommendation G.711)
              //   case 'AB': // 8 bit A-law (in accordance with ITU-T Recommendation G.711)
              //   default:
              waveformPaddingValue = multiplexGroup.string('x5400100a'); // VR = OB
              const waveformData = multiplexGroup.string('x54001010'); // VR = OB or OW (OB)
              // }
              break;

            case 16:
              switch (mg.waveformSampleInterpretation) {
                
                case 'SS': // signed 16 bit linear
                  if (!multiplexGroup.elements.x54001010) {
                    break;
                  }
                  const { dataOffset, length } = multiplexGroup.elements.x54001010;
                  //  let sampleSize = multiplexGroup.elements.x54001010.length / 2; // 16 bit!
                  const sampleSize = mg.numberOfWaveformSamples * mg.numberOfWaveformChannels;
                  // const sampleData = new Int16Array(dataSet.byteArray.buffer, sampleOffset, sampleSize);
                  const sampleData = new Int16Array(dataSet.byteArray.buffer, dataOffset, sampleSize);
                  // const sampleData = new Int16Array(byteArray, sampleOffset, sampleSize);
                  let pos = 0;

                  // 10 mm/mV is a rather standard value for ECG

                  for (let numSample = 0; numSample < mg.numberOfWaveformSamples; numSample++) {
                    for (let numChannel = 0; numChannel < mg.numberOfWaveformChannels; numChannel++) {
                      // mg.channels[numChannel].samples.push(sampleData[pos] * mg.channels[numChannel].channelDefinition.channelSensitivity);
                      mg.channels[numChannel].samples.push(sampleData[pos]);
                      pos++;
                      // sample = dataSet.byteArray, offset, ...
                    }
                  }
                  break;

                case 'US': // unsigned 16 bit linear
                  waveformPaddingValue = multiplexGroup.uint16('x5400100a'); // VR = OB or OW (OW->US)
                  waveformData = multiplexGroup.string('x54001010'); // VR = OB or OW
                  break;

                default:
                  break; // throw
              }
              break; // throw
            default:
              break;
          }

          /*
Channel Sensitivity: Nominal numeric value of unit quantity of sample. Required if samples represent defined (not arbitrary) units.
Channel Sensitivity Units Sequence: A coded descriptor of the Units of measure for the Channel Sensitivity.
Channel Sensitivity Correction Factor: Multiplier to be applied to encoded sample values to match units specified in Channel Sensitivity
Channel Baseline: Offset of encoded sample value 0 from actual 0 using the units defined in the Channel Sensitivity Units Sequence
*/
          let adjValue;
          for (let numChannel = 0; numChannel < mg.numberOfWaveformChannels; numChannel++) {
            const channel = mg.channels[numChannel];
            let baseline = Number(channel.channelDefinition.channelBaseline);
            let sensitivity = Number(channel.channelDefinition.channelSensitivity);
            let sensitivityCorrectionFactor = Number(channel.channelDefinition.channelSensitivityCorrectionFactor);

            if (isNaN(baseline)) baseline = 0;
            if (isNaN(sensitivity)) sensitivity = 1;
            if (isNaN(sensitivityCorrectionFactor)) sensitivityCorrectionFactor = 1;

            // ATM: Units hardcoded as uV. ToDo: Change this!
            // let units = channel.channelDefinition.channelSensitivityUnits.codeValue;

            // TODO: Sensitivity threshold
            for (let numSample = 0; numSample < mg.numberOfWaveformSamples; numSample++) {
              adjValue = -baseline + channel.samples[numSample] * sensitivity * sensitivityCorrectionFactor;
              channel.samples[numSample] = adjValue;
            }
          }

          // *** ToDo:
          // Automatic selection of units range depending on max / min values ??''
          // Automatic selection depending on SOP Class UID ?
          for (let numChannel = 0; numChannel < mg.numberOfWaveformChannels; numChannel++) {
            // const chartId = `myChart_${numChannel}`;
            const chartId = 'chartID';
            const yAxis = {};

            switch (mg.channels[numChannel].channelDefinition.channelSensitivityUnits.codeValue) {
              case 'uV':
                yAxis.min = -1500;
                yAxis.max = 1500;
                yAxis.conversionFactor = 100;
                yAxis.mesurementUnits = 'uV';
                break;

              case 'mV':
                // *** ToDo: proper rounding of values in y axis
                yAxis.min = -0.5;
                yAxis.max = 1.5;
                yAxis.conversionFactor = 0.1;
                yAxis.mesurementUnits = 'mV';
                break;

              case 'mm[Hg]': // Better 60 ~ 160 range ?
                yAxis.min = 0;
                yAxis.max = 200;
                yAxis.conversionFactor = 1;
                yAxis.mesurementUnits = 'mm[Hg]';
                break;

              default:
                yAxis.min = -1500;
                yAxis.max = 1500;
                yAxis.conversionFactor = 100;
                yAxis.mesurementUnits = 'uV';
            }

            yAxis.label = `${mg.channels[numChannel].channelDefinition.channelSensitivityUnits.codeMeaning} (${mg.channels[numChannel].channelDefinition.channelSensitivityUnits.codeValue})`;

            const channelDataParsed = {
              channels: mg.channels[numChannel],
              frequency: mg.samplingFrequency,
              axis: yAxis,
            };
            sequenceData.push(channelDataParsed);
          }
          ecgSequence.push(sequenceData);
        }
      });
    }
  }

  return ecgData;
};
